/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { getCurrentInstance, h, createVNode } from 'vue';

function useIcon() {
  var instance = getCurrentInstance();
  return function renderIconTNode(iconType, defaultIcons) {
    var iconContent;

    if (typeof instance.props[iconType] === "function") {
      iconContent = instance.props[iconType](h);
    } else if (instance.slots[iconType]) {
      iconContent = instance.slots[iconType] && instance.slots[iconType](null)[0];
    } else if (defaultIcons) {
      var Component = defaultIcons[instance.props.theme];
      iconContent = createVNode(Component, null, null);
    }

    return iconContent;
  };
}

export { useIcon };
//# sourceMappingURL=icon.mjs.map
